import { CoreUiException } from "./core-ui-exception";

/**
 * Occurs when a user is not authorzied to perform a task
 */
export class ForbiddenException extends CoreUiException {

    constructor(message: string, originaError?: any) {

        super("ForbiddenException", message, originaError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ForbiddenException.prototype);
    }
}
